import CircularProgress from '@material-ui/core/CircularProgress';
import { LayoutResultat } from '@orientaction/layouts';
import RedesignImage from '../../shared/components/RedesignImage';
import InlineSignup from '../../shared/InlineSignup';
import EbookReaderHeader from '../Dev/components/EbookReaderHeader';
import FloatingEbookActions from '../Dev/components/FloatingEbookActions';
import CustomEbookBlock from './components/CustomEbookBlock';
import { useCustomEbookReader } from './hooks/useCustomEbookReader';
import { useCustomEbookStyles } from './index.styles';

const CustomEbookReader = () => {
  const classes = useCustomEbookStyles();
  const {
    blocks,
    coverUrl,
    catalogEbookId,
    ebookId,
    index,
    loading,
    loadError,
    readOnly,
    showSignup,
    toBack,
    updateFreeQuestion,
    updateQCM,
    updateQCMText,
  } = useCustomEbookReader();

  const scrollToSection = (blockIndex: number) => {
    const element = document.getElementById(`custom-title-${blockIndex}`);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <LayoutResultat
      isWhite={true}
      showLogo={false}
      toBack={toBack}
      index={Number(index)}
      hideHeader={true}>
      <EbookReaderHeader index={Number(index)} toBack={toBack} />
      <main className={classes.page}>
        {loading ? (
          <div className={classes.loadingCenter}>
            <CircularProgress />
          </div>
        ) : loadError ? (
          <p role="alert">{loadError}</p>
        ) : (
          <>
            {showSignup && (
              <InlineSignup
                testImage={coverUrl}
                ebookResultId={ebookId || ''}
                ebookIndex={index}
                authorizedEbookId={catalogEbookId}
                contentType="ebook"
              />
            )}

            <article className={showSignup ? classes.hidden : classes.readerCard}>
              {coverUrl && (
                <div id="page-0" className="ebook-cover">
                  <RedesignImage src={coverUrl} alt="Couverture de l'ebook" />
                </div>
              )}

              <div className={classes.blocks}>
                {blocks.map((block, blockIndex) => (
                  <section
                    key={block?.uniqueIdContent || block?.id || `block-${blockIndex}`}
                    className={classes.block}>
                    <CustomEbookBlock
                      block={block}
                      blocks={blocks}
                      index={blockIndex}
                      readOnly={readOnly}
                      onFreeQuestionChange={updateFreeQuestion}
                      onQcmChange={updateQCM}
                      onQcmTextChange={updateQCMText}
                      onScrollToSection={scrollToSection}
                    />
                  </section>
                ))}
              </div>
            </article>

            {!showSignup && <FloatingEbookActions summaryHref="custom-summary" />}
          </>
        )}
      </main>
    </LayoutResultat>
  );
};

export default CustomEbookReader;
